import React, { Component } from "react";
import "./style.scss";
export default class SignUp extends Component {
  render() {
    const { pricing } = this.props;

    return (
      <section className="aboss__signup">
        {pricing === 49 && <h1>Sign Up for ABOSS Artist (Month)</h1>}
        {pricing === 528 && <h1>Sign Up for ABOSS Artist (Year)</h1>}
        {pricing === 1572 && (
          <h1 className="aboss__signup-agency">
            Sign Up for ABOSS Agency Small
          </h1>
        )}
        {pricing === 3456 && (
          <h1 className="aboss__signup-agency">
            Sign Up for ABOSS Agency Medium
          </h1>
        )}
        {pricing === 6264 && (
          <h1 className="aboss__signup-agency">
            Sign Up for ABOSS Agency Large
          </h1>
        )}

        {pricing === 49 && (
          <iframe src="https://aboss.typeform.com/to/aYYQon"></iframe>
        )}
        {pricing === 528 && (
          <iframe src="https://aboss.typeform.com/to/sknhCo"></iframe>
        )}
        {pricing === 1572 && (
          <iframe src="https://aboss.typeform.com/to/RaWt2Q"></iframe>
        )}
        {pricing === 3456 && (
          <iframe src="https://aboss.typeform.com/to/AXU6SE"></iframe>
        )}
        {pricing === 6264 && (
          <iframe src="https://aboss.typeform.com/to/r5d978"></iframe>
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// src/views/sign-up/step_3.js